<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>报表管理</el-breadcrumb-item>
      <el-breadcrumb-item>智能绩效表</el-breadcrumb-item>
    </el-breadcrumb>

    <div style="display: flex;justify-items: center">
      <el-date-picker
        v-model="ruleRequest.selectDay"
        type="daterange"
        range-separator="至"
        size="mini"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="selectReportDataDay"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
      <div>
        <el-date-picker
          v-model="ruleRequest.startYear"
          type="year"
          size="mini"
          placeholder="开始年份"
          value-format="yyyy"
          @change="selectStartYear"
          style="width: 150px"
        >
        </el-date-picker>
        <span style="color: #8c939d;font-size: 12px">至</span>
        <el-date-picker
          v-model="ruleRequest.endYear"
          type="year"
          size="mini"
          placeholder="结束年份"
          value-format="yyyy"
          @change="selectEndYear"
          style="width: 150px"
        >
        </el-date-picker>
      </div>
      <el-select value filterable v-model="selectAreaId" v-if="orgLevel == 1" placeholder="请选择区域" clearable
                 style="width: 150px" size="mini" @change="getArea">
        <el-option
          v-for="item in areaList"
          :key="item.id"
          :label="item.orgName"
          :value="item.id">
        </el-option>
      </el-select>
      <el-select v-model="selectUserId" clearable value filterable placeholder="请选择员工"
                 style="width: 150px" size="mini" @change="getUser">
        <el-option
          v-for="user in userList"
          :key="user.id"
          :label="user.userName"
          :value="user.id">
        </el-option>
      </el-select>
      <el-select v-model="selectPerfType" clearable value filterable placeholder="请选择绩效方式"
                 style="width: 150px" size="mini" @change="getType">
        <el-option
          v-for="type in perfTypeList"
          :key="type.en"
          :label="type.label"
          :value="type.en">
        </el-option>
      </el-select>
      <el-button size="mini" style="margin-left: 5px;" @click="loadUserPerfRule">查询</el-button>
    </div>

    <el-table :data="userPerfRuleList" fit border stripe="stripe"
              height="550px" :cell-style="{padding: '5px'}"
              :header-cell-style="{background:'#eff3f8', color:'#333', padding: '5px'}"
              :row-style="{height: '0'}">
      <el-table-column
        align="center"
        prop="userName"
        label="员工姓名" >
      </el-table-column>
      <el-table-column
        align="center"
        prop="areaName"
        width="120"
        label="所属区域" >
      </el-table-column>
      <el-table-column
        align="center"
        prop="shopName"
        width="150"
        label="所属门店" >
      </el-table-column>
      <el-table-column
        align="center"
        prop="subScore"
        :default-sort="{ order: 'descending' }" sortable
        label="扣分" >
      </el-table-column>
      <el-table-column
        align="center"
        prop="addScore"
        :default-sort="{ order: 'descending' }" sortable
        label="加分" >
      </el-table-column>
      <el-table-column
        align="center"
        prop="lejuan"
        :default-sort="{ order: 'descending' }" sortable
        label="乐捐" >
      </el-table-column>
      <el-table-column
        align="center"
        prop="jiangjin"
        :default-sort="{ order: 'descending' }" sortable
        label="奖金" >
      </el-table-column>
      <el-table-column
        align="center"
        prop="jinxing"
        label="金星" >
      </el-table-column>
      <el-table-column
        align="center"
        prop="yinxing"
        label="银星" >
      </el-table-column>
      <el-table-column
        align="center"
        prop="jinzhang"
        label="金章" >
      </el-table-column>
      <el-table-column
        align="center"
        prop="zhFz"
        :default-sort="{ order: 'descending' }" sortable
        label="综合分值" >
      </el-table-column>
    </el-table>
    <div style="margin-top: 3px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      orgId: '',
      userId: '',
      orgLevel: '',
      orgList: [],
      areaList: [],
      userList: [],
      ruleRequest:{
        selectDay:'',
        startYear:'',
        endYear:'',
        startDate:'',
        endDate:'',
        areaId:'',
        userId:'',
        perfType:'',
        pageNum:'',
        pageSize:'',
      },
      perfTypeList:[
        {en:'jiangjin', label:'奖金'},
        {en:'jinzhang', label:'金章'},
        {en:'jinxing', label:'金星'},
        {en:'yinxing', label:'银星'},
        {en:'lejuan', label:'乐捐'},
      ],
      selectAreaId:'',
      selectUserId:'',
      selectPerfType:'',
      userPerfRuleList:[],
      currentPage: 1,
      pageSize:20,
      pageTotal:0,
    }
  },
  methods:{
    selectReportDataDay(data){
      if (data == null){
        this.ruleRequest.selectDay = '';
        this.ruleRequest.startDate = '';
        this.ruleRequest.endDate = '';
      } else {
        this.ruleRequest.selectDay = data;
        this.ruleRequest.startDate = data[0];
        this.ruleRequest.endDate = data[1];
      }
    },
    selectStartYear(data){
      if (data == null){
        this.ruleRequest.startYear = '';
      } else {
        this.ruleRequest.startYear = data;
      }
    },
    selectEndYear(data){
      if (data == null){
        this.ruleRequest.endYear = '';
      } else {
        this.ruleRequest.endYear = data;
      }
    },
    async getArea(data){
      if (data !== ''){
        this.ruleRequest.areaId = data;
      } else {
        this.ruleRequest.areaId = 0;
      }
    },
    getUser(data){
      if (data !== ''){
        this.selectUserId = data;
        this.ruleRequest.userId = data;
      } else {
        this.selectUserId = '';
        this.ruleRequest.userId = '';
      }
    },
    getType(data){
      if (data !== ''){
        this.selectPerfType = data;
        this.ruleRequest.perfType = data;
      } else {
        this.selectPerfType = '';
        this.ruleRequest.perfType = '';
      }
    },
    async loadAreaOrgs(){
      const {data:res} = await this.$http.get(`/orgs/area/orgId/${this.orgId}`);
      if (res.code === 200){
        this.areaList = res.data;
      }
    },
    loadUserPerfRule(){
      this.ruleRequest.pageNum = this.currentPage;
      this.ruleRequest.pageSize = this.pageSize;
      this.loadUserPerfRuleCount();
      this.loadUserPerfRuleList();
    },
    async loadUserPerfRuleCount(){
      const {data:res} = await this.$http.post(`/report/user/perf/rule/count`, this.ruleRequest);
      this.pageTotal = res.totalPage;
    },
    async loadUserPerfRuleList(){
      const {data:res} = await this.$http.post(`/report/user/perf/rule/list`, this.ruleRequest);
      this.userPerfRuleList = res.data;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadUserPerfRuleList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadUserPerfRuleList();
    },
    async loadUsers(){
      if (this.orgLevel < 3){
        const {data:res} = await this.$http.get(`/report/users`);
        this.userList = res.data;
      } else {
        const {data:res} = await this.$http.get(`/org/users/${this.orgId}`);
        this.userList = res.data;
      }
    }
  },
  created() {
    this.orgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.orgLevel = window.sessionStorage.getItem("orgLevel");
    this.authorities = window.sessionStorage.getItem('authorities');
    if (this.orgLevel == 1){
      this.loadAreaOrgs();
    }
    if (this.orgLevel == 2){
      this.ruleRequest.areaId = this.orgId;
    }
    this.loadUsers();
  }
}
</script>

<style lang="less" scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  //align-items: flex-start;
  height: 90vh;
}
.left_con::-webkit-scrollbar {
  width: 0 !important
}

.left_con{
  //display: flex;
  //justify-content: start;
  height: 100%;
  overflow-y: auto;
  //flex: 1;
  width: 100px;
}
.left_inner_con{
  width: 100%;
  height: 90vh;
  overflow-y: auto;
}
.left_inner_con::-webkit-scrollbar {
  width: 0 !important
}
.table_container{
  //flex: 1;
  width: 800px;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/ .el-dialog__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
/deep/.el-dialog__body{
  padding-top: 10px;
}
.dialog-height{
  height: 600px !important;
}
.dialog-footer{
  display: flex;
  margin: 10px 0;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/ReportPerfRule.vue